module.exports = __webpack_public_path__ + "media/images/icons/en-flag-87d68db459e1e83974188051ef26e7d2.svg";